import { RouterModule, Routes } from "@angular/router"; 
import { NgModule } from "@angular/core"; 

const routes: Routes = [
  {
		path: '',
		loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
	},
];
  
  @NgModule({
    imports: [
       RouterModule.forRoot(routes, { useHash: true })
    ],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }
  